import { gql } from '@apollo/client';

export const fetchShipToGrouped = gql`
  query FetchShipToGrouped($searchParams: ShipToPartySearchParams, $pageParams: ShipToPartyPageParams) {
    shipToPartyGrouped(searchParams: $searchParams, pageParams: $pageParams) {
      totalCount
      nodes {
        key
        data {
          name
          id
          addressLine1
          addressLine2
          city
          state
          country
          postcode
          priceEligibility
          taxId
          taxIds {
            id
            label
            metadata {
              vatStatus
            }
            taxExempt
          }
          taxLabels {
            region
            taxIdLabels {
              description
              displayName
              type
              metadata {
                type
                labels {
                  default
                  label
                  vatStatus
                }
              }
            }
          }
        }
      }
    }
  }
`;
